<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */

    /**
     * @typedef {Object} ProcessInfo
     * @property {string} label - user-friendly process name
     */

    /**
     * @typedef {Object} Props
     * @property {ProcessInfo[]} denyProcesses
     */

    /** @type {Props} */
    let { denyProcesses } = $props();
</script>

<style>
    ul {
        margin-block: 2rem 2.5rem;
        padding-inline-start: 4rem;
    }
</style>

<ul>
    {#each denyProcesses as processInfo (processInfo)}
        <li>{processInfo.label || processInfo.name}</li>
    {/each}
</ul>
